import { useState, useEffect, useContext } from 'react';
import { g as getCookie, s as setCookie, r as removeCookie } from '../Timer-c078a2ef.js';
import { Y as ToastContext, a4 as AppContext } from '../Wizard-9d01e97c.js';
export { bp as ApiContext, bq as ApiContextProvider, bt as EnvironmentContext, bu as EnvironmentContextProvider, br as useApi, bs as useClickOutside, V as useDebounce, bA as useDidMountEffect, bv as useEnvironment, bw as useFetchImage, bx as useLogout, by as useMediaQuery, U as usePermissions, bz as useRedirectToLogin, n as useViewport } from '../Wizard-9d01e97c.js';
import { _ as __assign } from '../tslib.es6-896f83a9.js';
import '../accessTokens-74425a4a.js';
import '@toast-ui/react-editor';
import 'react-router-dom';
import 'react-dom';
import 'react-jss';
import 'js-cookie';
import '../index.es-840d4524.js';
import '../supportsCSSPropertyValue-b6b8cdb3.js';
import '../sonikaTheme-c58de996.js';
import '../uploadFile-6fa21335.js';
import '../filterDistinct-c0340793.js';
import '../backgroundColors-77340375.js';
import '../millisecondsToDateParts-8e4a9313.js';
import 'path';

var ACCESS_TOKEN_COOKIE_NAME = 'access_token';
var REFRESH_TOKEN_COOKIE_NAME = 'refresh_token';
var useAccessTokens = function () {
    var _a = useState({
        accessToken: getCookie(ACCESS_TOKEN_COOKIE_NAME),
        refreshToken: getCookie(REFRESH_TOKEN_COOKIE_NAME),
    }), accessTokens = _a[0], setAccessTokens = _a[1];
    useEffect(function () {
        if (accessTokens) {
            setCookie(ACCESS_TOKEN_COOKIE_NAME, accessTokens.accessToken);
            setCookie(REFRESH_TOKEN_COOKIE_NAME, accessTokens.refreshToken);
        }
        else {
            removeCookie(ACCESS_TOKEN_COOKIE_NAME);
            removeCookie(REFRESH_TOKEN_COOKIE_NAME);
        }
    }, [accessTokens]);
    return [accessTokens, setAccessTokens];
};

var titleFormat = 'Sonika - %1';
/**
 * Hook for updating document title with watchable dependencies (by using useEffect() )
 * @param titleOrFn can be a String or a function.
 * @param deps? if provided, the title will be updated when one of these values changes
 * */
var useTitle = function (titleOrFn, deps) {
    useEffect(function () {
        var title = typeof titleOrFn === 'function' ? titleOrFn(deps) : titleOrFn;
        title = titleFormat.replace('%1', title);
        window.document.title = title;
    }, deps);
};

var useToasts = function () {
    var context = useContext(ToastContext);
    if (!context) {
        throw Error('The `useToasts` hook must be called from a descendent of the `ToastProvider`.');
    }
    return __assign({}, context);
};

var useWindowScroll = function (scrollableParent) {
    var scrollElement = scrollableParent || window;
    var _a = useState({
        x: scrollableParent ? scrollableParent.scrollLeft : window.pageXOffset,
        y: scrollableParent ? scrollableParent.scrollTop : window.pageYOffset,
    }), state = _a[0], setState = _a[1];
    useEffect(function () {
        var handler = function () {
            setState({
                x: scrollableParent ? scrollableParent.scrollLeft : window.pageXOffset,
                y: scrollableParent ? scrollableParent.scrollTop : window.pageYOffset,
            });
        };
        scrollElement.addEventListener('scroll', handler, {
            capture: false,
            passive: true,
        });
        return function () {
            scrollElement.removeEventListener('scroll', handler);
        };
    }, []);
    return state;
};

var useCurrentUser = function () {
    var currentUser = useContext(AppContext).currentUser;
    return currentUser;
};

export { ACCESS_TOKEN_COOKIE_NAME, REFRESH_TOKEN_COOKIE_NAME, useAccessTokens, useCurrentUser, useTitle, useToasts, useWindowScroll };
//# sourceMappingURL=index.js.map
